import { memo, useEffect, useState, useRef } from "react"

import ProductService from "@/services/product"
import { Stack, Alert, CloseButton, Image, EmptyState, Center, Button, Container, Box, Table, IconButton, Text, Card, VStack, HStack, Separator, Heading, Flex } from "@chakra-ui/react"

import { formatCurrency } from "@/utilities/number"
import { LuPencil } from "react-icons/lu"

import { StepperInput } from "@/components/ui/stepper-input"
import { useApp } from "contexts/app"

import CtvService from "services/ctv"
import { useNavigate, useParams, useSearchParams } from "react-router"
import { Grid, GridItem } from "@chakra-ui/react"
import WithLoginPage from "@/components/withlogin"
import moment from "moment";
import { useAuth } from "contexts/auth";
import { useStore } from "contexts/store";
import Withdraw from "./Withdraw"
import Share from "./Share"
import Product from "./Product"
import { FaShare } from "react-icons/fa"
import MenuItem from "components/menu-item"
import DateRangePicker from "components/date-range-picker"

const service = new CtvService();

const PointPage = () => {

    const { setProcessing, setPageTitle, showToast } = useApp();
    const [profile, setProfile] = useState({ order_list: [] })
    const { user } = useAuth();

    const { copyText } = useApp();
    const { store } = useStore();

    const [showWithdraw, setShowWithdraw] = useState(false)
    const [showShare, setShowShare] = useState(false);

    const [filter, setFilter] = useState({
        range: {
            start: moment().startOf("D"),
            end: moment().endOf("D"),
        }
    })

    const navigate = useNavigate();
    useEffect(() => {
        setPageTitle("Cộng tác viên")
    }, [setPageTitle])

    useEffect(() => {

        load();
    }, [filter])


    const load = async () => {
        var range = { start: filter.range.start.toDate(), end: filter.range.end.toDate() };

        setProcessing(true)
        var a = await service.me({ range });
        setProfile(a);
        setProcessing(false)
    }

    const copyShareLink = () => {
        //  copyText(`${store.web.full_url}?ref=${user.id}`)
        setShowShare(true)
    }
    const withdraw = () => {
        setShowWithdraw(true)
    }

    const onFilterRangeChange = (e) => {
        setFilter({ range: e })
    }

    return (
        <div style={{ paddingBottom: 75 }}>

            <Grid templateColumns="repeat(2, 1fr)" gap="6">

                <GridItem>
                    <Card.Root size="sm">

                        <Card.Body color="fg.muted">

                            <Center fontSize="xl">{formatCurrency(profile.commission)}</Center>
                            <Center fontSize="sm">Số dư hoa hồng</Center>
                            <Center fontSize="sm" ><Button variant={"plain"} onClick={withdraw}>Rút tiền</Button></Center>

                        </Card.Body>
                    </Card.Root>
                </GridItem>
                <GridItem>
                    <Card.Root size="sm">

                        <Card.Body color="fg.muted">

                            <Center fontSize="xl">{store.collaborator.commission}%</Center>
                            <Center fontSize="sm">Tỉ lệ hoa hồng</Center>
                            <Center fontSize="sm"><Button variant={"plain"} onClick={copyShareLink}>
                                <Text lineClamp={2} >
                                    Link tiếp thị

                                    của tôi
                                </Text>

                            </Button></Center>



                        </Card.Body>
                    </Card.Root>
                </GridItem>

            </Grid>
            <div>


                <Flex justifyContent={"flex-end"}>
                    <DateRangePicker value={filter.range} onChange={onFilterRangeChange}></DateRangePicker>

                </Flex>
            </div>
            <Grid templateColumns="repeat(2, 1fr)" gap="6">
                <GridItem>

                    <Card.Root size="sm">

                        <Card.Body color="fg.muted">

                            <Center fontSize="xl">{formatCurrency(profile.commission_all)}</Center>
                            <Center fontSize="sm">

                                <Text lineClamp={2} >
                                    Hoa hồng

                                    ước tính
                                </Text>


                            </Center>


                        </Card.Body>
                    </Card.Root>
                </GridItem>
                <GridItem>
                    <Card.Root size="sm" height={"100%"}>

                        <Card.Body color="fg.muted">

                            <Center fontSize="xl">{formatCurrency(profile.orders)}</Center>
                            <Center fontSize="sm">Đơn hàng</Center>




                        </Card.Body>
                    </Card.Root>
                </GridItem>



                {/* <GridItem colSpan={2}>
                    <Card.Root size="sm">


                        <Card.Body color="fg.muted">
                            <Flex justifyContent={"flex-start"}>Đơn hàng</Flex>
                            {profile.order_list.length > 0 &&
                                <Table.ScrollArea maxHeight="250px">

                                    <Table.Root size="sm">
                                        <Table.Header>
                                            <Table.Row>
                                                <Table.ColumnHeader>Đơn hàng</Table.ColumnHeader>
                                                <Table.ColumnHeader>Khách hàng</Table.ColumnHeader>
                                                <Table.ColumnHeader textAlign="end">Hoa hồng</Table.ColumnHeader>
                                            </Table.Row>
                                        </Table.Header>
                                        <Table.Body style={{ maxHeight: 300, overflowY: "scroll" }}>
                                            {profile.order_list.map((item) => (
                                                <Table.Row key={item.id}>
                                                    <Table.Cell>{item.id}</Table.Cell>
                                                    <Table.Cell>{item.customer.full_name}</Table.Cell>
                                                    <Table.Cell textAlign={"end"}>{formatCurrency(item.commission)}</Table.Cell>

                                                </Table.Row>
                                            ))}


                                        </Table.Body>



                                    </Table.Root>
                                </Table.ScrollArea>

                            }
                            {profile.order_list.length == 0 &&
                                <EmptyState.Root >
                                    <EmptyState.Content>
                                        <EmptyState.Indicator>

                                        </EmptyState.Indicator>
                                        <VStack textAlign="center">
                                            <EmptyState.Title>Chưa có đơn hàng nào</EmptyState.Title>
                                            <EmptyState.Description>
                                                Sao chép link tiếp thị của bạn và chia sẻ lên Facebook hoặc Zalo để nhận hoa hồng nhé!
                                            </EmptyState.Description>
                                            <Button onClick={e => setShowShare(true)}><FaShare></FaShare> Chia sẻ</Button>
                                        </VStack>
                                    </EmptyState.Content>
                                </EmptyState.Root>
                            }


                        </Card.Body>
                    </Card.Root>
                </GridItem> */}
                <GridItem colSpan={2}>
                    <Card.Root size="sm">
                        <Card.Body>
                            <MenuItem label="Lịch sử hoa hồng và rút tiền" extra={""} onClick={e => navigate("/ctv/history")} showSeparator={false}></MenuItem>
                        </Card.Body>
                    </Card.Root>
                </GridItem>

                <GridItem colSpan={2}>
                    <Product></Product>
                </GridItem>
            </Grid>
            <Share open={showShare} onOpenChange={e => setShowShare(false)}></Share>
            <Withdraw open={showWithdraw} onOpenChange={e => setShowWithdraw(e)} amount={profile.commission}></Withdraw>




        </div >
    )
}







const withLogin = () => (<WithLoginPage><PointPage></PointPage></WithLoginPage>)


export default memo(withLogin)